export default __webpack_public_path__ + "static/media/pioneer-10.739ab0eb.png";